var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2898",
    "data-name": "Group 2898",
    transform: "translate(-451.5 -242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-person",
    "data-name": "Icon ionic-md-person",
    d: "M19.9,19.9a7.7,7.7,0,1,0-7.7-7.7A7.72,7.72,0,0,0,19.9,19.9Zm0,3.849c-5.1,0-15.4,2.6-15.4,7.7V35.29H35.29V31.441C35.29,26.342,24.994,23.744,19.9,23.744Z",
    transform: "translate(447 247.71)",
    fill: "#00bfef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-information-circle-outline",
    "data-name": "Icon ionic-ios-information-circle-outline",
    transform: "translate(473.688 238.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    "data-name": "Path 3184",
    d: "M16.552,11.447a.765.765,0,1,1,.761.742A.743.743,0,0,1,16.552,11.447Zm.052,1.325h1.417v5.347H16.6Z",
    transform: "translate(-6.223 -3.463)",
    fill: "#00bfef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3185",
    "data-name": "Path 3185",
    d: "M11.093,4.414A6.677,6.677,0,1,1,6.37,6.37a6.635,6.635,0,0,1,4.724-1.956m0-1.039a7.718,7.718,0,1,0,7.718,7.718,7.717,7.717,0,0,0-7.718-7.718Z",
    fill: "#00bfef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBlue);
export default __webpack_public_path__ + "static/media/PersonBlue.42c893627d6b7036beafc110b22dfb6c.svg";
export { ForwardRef as ReactComponent };